<template>
  <div class="prescriptionInput">
    <div class="header-btn-g" v-if="!disabled">
      <Button size="small" type="text" @click="expand = !expand"
        >快捷百年方
        <Icon v-if="!expand" type="ios-arrow-down" />
        <Icon v-else type="ios-arrow-up" />
      </Button>
      <Button @click="getData" size="small" class="btn5" type="info" ghost
        >上次就诊处方</Button
      >
    </div>
    <div class="tag-g" v-if="expand">
      <Button
        size="small"
        v-for="(item, index) in drugListPage"
        @click="addDrug(item)"
        :key="index"
        >{{ item.label }}</Button
      >
    </div>
    <drugTable :drugList="value" @change="change" :disabled="disabled" />
  </div>
</template>

<script>
import drugTable from "./drugTable.vue";
import { mapGetters } from "vuex";
import request from "@/utils/request";
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    drugTable,
  },
  computed: {
    ...mapGetters([
      "hundredDrugs", //百年方
      "drugListPage",
      "drug",
    ]),
  },
  data() {
    return {
      // 是否展开
      expand: false,
    };
  },
  methods: {
    pushDrugList(drugList) {
      let list = [];
      drugList.forEach((i) => {
        let item = this.drug.find((j) => j.Drug_Code == i.drugCode);
        list.push({
          ...item,
          Amount: i.amount,
        });
      });
      this.$emit("input", list);
      this.$emit("change", list);
    },
    addDrug(item) {
      request
        .post("/base/convertToDrugs", {
          drugList: [{ drugCode: item.drugCode, amount: 1 }],
        })
        .then((res) => {
          this.pushDrugList(res.result);
        });
    },
    getData() {
      let obj = {
        pageNo: 1,
        pageSize: 3,
        patientCode: this.info.patientCode,
        searchType: 1,
      };
      this.api2("listPatientMainSymptom", obj).then((res) => {
        let list = res.result;
        if (list.length) {
          let drugList = list[0].diagnosticDrugsVOList;
          this.pushDrugList(drugList);
        } else {
          this.$Message.info("未查询到上次就诊处方");
        }
      });
    },
    change() {
      this.$emit("input", this.value);
      this.$emit("change", this.value);
    },
  },
  created() {
    this.$store.dispatch("getDrugListPage");
  },
};
</script>

<style lang="scss" scoped>
.prescriptionInput {
  padding-bottom: 5px;
  position: relative;
  .header-btn-g {
    position: absolute;
    top: -35px;
    right: 0;
  }
  .ivu-btn {
    margin-right: 10px;
  }
  .tag-g {
    margin-bottom: 10px;
    .ivu-tag {
      cursor: pointer;
    }
  }
  .ivu-tag-size-medium {
    height: 28px;
    line-height: 28px;
  }
  .btn5 {
    background: none;
  }
}
</style>